"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const _ = __importStar(require("lodash"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const services_1 = require("services");
const Clients_1 = require("components/partial/Clients");
const RoadmapTypeContactEntity_1 = require("types/api/entity/RoadmapTypeContactEntity");
const native_1 = require("@react-navigation/native");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const roadmap_1 = require("types/api/response/roadmap");
const ModalCancelRoadmapAdd_1 = __importDefault(require("components/modal/ModalCancelRoadmapAdd"));
const ModalSelectRoadmapClientNewBrand_1 = __importDefault(require("components/modal/ModalSelectRoadmapClientNewBrand"));
const react_dropzone_1 = __importDefault(require("react-dropzone"));
const ModalRoadmapMap_1 = __importDefault(require("components/modal/ModalRoadmapMap"));
const PlanningRoadmapAdd = ({ route, navigation }) => {
    const { client: clientParam, clear: clearParam, clearToken: clearTokenParam, date: dateParam, } = route?.params ?? {};
    //console.log("clearParam", clearParam);
    //console.log("dateParam", dateParam);
    const toast = (0, native_base_1.useToast)();
    const existentClientChanged = React.useRef(false);
    const [initResponse, setInitResponse] = React.useState();
    const [client, setClient] = React.useState(clientParam);
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        if (clientParam) {
            existentClientChanged.current = true;
            setClient(clientParam);
        }
    }, [clientParam?.id]));
    //console.log("clear", clear);
    const [objectiveContactChecklist, setObjectiveContactChecklist] = React.useState();
    const [clientNew, setClientNew] = React.useState(true);
    const [clientNewName, setClientNewName] = React.useState("");
    const [clientNewRuc, setClientNewRuc] = React.useState("");
    const [clientNewPhone, setClientNewPhone] = React.useState("");
    const [clientNewAddress, setClientNewAddress] = React.useState("");
    const [clientNewPot, setClientNewPot] = React.useState(false);
    const [address, setAddress] = React.useState();
    const latRef = React.useRef();
    const lngRef = React.useRef();
    const userLatRef = React.useRef();
    const userLngRef = React.useRef();
    const [objectiveContactVisible, setObjectiveContactVisible] = React.useState(false);
    const [roadmapObjectiveContact, setRoadmapObjectiveContact] = React.useState();
    const [roadmapTypeContact, setRoadmapTypeContact] = React.useState();
    const inputDateRef = React.useRef();
    const [day, setDay] = React.useState(() => {
        console.log("useState");
        console.log(dateParam);
        return dateParam;
    });
    const [hour, setHour] = React.useState();
    const [minute, setMinute] = React.useState();
    const [isLoading, setIsLoading] = React.useState(false);
    const [showCancelRoadmapAddDialog, setShowCancelRoadmapAddDialog] = React.useState(false);
    const [showSelectClientNewBrand, setShowSelectClientNewBrand] = React.useState(false);
    const [brandsClientNewSelected, setBrandsClientNewSelected] = React.useState();
    const [showModalMap, setShowModalMap] = React.useState(false);
    //file
    const [files, setFiles] = React.useState([]);
    const onDrop = React.useCallback((acceptedFiles) => {
        setFiles(acceptedFiles);
    }, []);
    //
    const dropzoneRef = React.createRef();
    const onBackPressed = () => {
        setShowCancelRoadmapAddDialog(true);
    };
    const onContinueEditingYesPressed = () => {
        setShowCancelRoadmapAddDialog(false);
    };
    const onContinueEditingNoPressed = () => {
        setShowCancelRoadmapAddDialog(false);
        navigation.navigate("PlanningRoadmapName");
    };
    const onClientNewPressed = () => {
        setClientNew(true);
    };
    const onClientNoNewPressed = () => {
        setClientNew(false);
    };
    const onSocioPressed = () => {
        navigation.navigate(Clients_1.name, {
            origin: "PlanningRoadmapAdd",
        });
    };
    const onRoadmapTypeContactPressed = (roadmapTypeContact) => {
        setRoadmapTypeContact(roadmapTypeContact);
    };
    const onNameChanged = (e) => {
        setClientNewName(e.target.value);
    };
    const onRucChanged = (e) => {
        setClientNewRuc(e.target.value);
    };
    const onPhoneChanged = (e) => {
        setClientNewPhone(e.target.value);
    };
    const onAddressChanged = (e) => {
        setClientNewAddress(e.target.value);
    };
    const onDayPressed = () => {
        //console.log(inputDateRef.current);
        inputDateRef.current.showPicker();
    };
    const onClearDatePressed = () => {
        setDay("");
    };
    const onClearHourMinutePressed = () => {
        setHour("");
        setMinute("");
    };
    const onAddPressed = () => {
        const onSuccess = () => {
            navigation.navigate("PlanningRoadmapName");
        };
        const onError = (msg) => {
            toast.show({ description: msg });
        };
        (0, services_1.doRoadmapCreate)({
            params: {
                data: {
                    cardCode: client?.id,
                    tipoContacto: roadmapTypeContact?.code,
                    fecha: day,
                    hora: hour,
                    minuto: minute,
                    clienteNuevo: clientNew == true ? "1" : undefined,
                    nombre: clientNewName,
                    ruc: clientNewRuc,
                    telefono: clientNewPhone,
                    direccion: clientNewAddress,
                    potencialCliente: clientNewPot == true ? 1 : 0,
                    marcas: brandsClientNewSelected?.map(e => e.code)?.join(","),
                    geoLatitud: latRef.current?.toString(), //"";
                    geoLongitud: lngRef.current?.toString(), //"";
                    userLatitud: userLatRef.current?.toString(),
                    userLongitud: userLngRef.current?.toString(),
                    geoDireccion: address, //"";
                    objetivoContacto: objectiveContactChecklist
                        ?.flatMap(e => e.opciones)
                        ?.map(e => {
                        return {
                            code: e?.code,
                            check: e?.check,
                        };
                    }),
                },
                fotolocal: files[0],
            },
            callback: {
                onSuccess: onSuccess,
                onFail: onError,
                onLoading: setIsLoading,
            },
        });
    };
    const onObjectivePressed = () => {
        setObjectiveContactVisible(old => !old);
    };
    const onObjectiveContactOptionPressed = (item, option) => {
        setObjectiveContactChecklist(old => {
            const news = old?.map(e => {
                return {
                    code: e.code,
                    nombre: e.nombre,
                    opciones: e.opciones?.map(option => {
                        return {
                            code: option.code,
                            name: option.name,
                            check: option.check,
                        };
                    }),
                };
            });
            news?.forEach(it => {
                it.opciones?.forEach(opt => {
                    if (it.code == item.code && option.code == opt.code) {
                        opt.check = opt.check == "1" ? "0" : "1";
                    }
                });
            });
            return news;
        });
    };
    const renderItem = ({ item }) => {
        return <ObjectiveContactItem item={item} onItemPressed={onObjectiveContactOptionPressed}/>;
    };
    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                userLatRef.current = position.coords?.latitude;
                userLngRef.current = position.coords?.longitude;
            }, e => { });
            /*navigator.permissions.query({name: "geolocation"}).then(permissionStatus => {
                console.log("permissionStatus", permissionStatus);
                if (permissionStatus.state === "denied") {
                    alert("Please allow location access.");
                    window.location.href = "app-settings:location";
                } else {
                }
            });*/
        }
        else {
            alert("Geolocation is not supported in your browser.");
        }
    }
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        const onSuccess = (response) => {
            setInitResponse(response);
            setObjectiveContactChecklist(response.data?.objetivoContacto);
            if (clientNew) {
                const prospecting = response.data?.objetivosContacto?.find(e => e.code == roadmap_1.RoadmapObjectiveContact.Prospecting);
                setRoadmapObjectiveContact(prospecting);
            }
            else {
                const planning = response.data?.objetivosContacto?.find(e => e.code == roadmap_1.RoadmapObjectiveContact.Planning);
                setRoadmapObjectiveContact(planning);
            }
        };
        (0, services_1.doRoadmapInit)({
            params: {},
            callback: {
                onSuccess,
            },
        });
        return () => {
            console.log("useFocusEffect return");
        };
    }, [clearParam]));
    React.useEffect(() => {
        console.log("clearParam", clearParam);
        getLocation();
        if (clearParam == true) {
            setClient(undefined);
            setObjectiveContactVisible(false);
            setRoadmapTypeContact(undefined);
            setDay(dateParam);
            setHour(undefined);
            setMinute("");
            setClientNew(true);
            setClientNewName("");
            setClientNewRuc("");
            setClientNewPhone("");
            setClientNewAddress("");
            setAddress(undefined);
            setClientNewPot(false);
            latRef.current = undefined;
            lngRef.current = undefined;
            setFiles([]);
            setBrandsClientNewSelected([]);
        }
        return () => {
            console.log("React.useEffect return");
        };
    }, [clearTokenParam]);
    //console.log("clientNewPot", clientNewPot);
    return (<>
			<native_base_1.ScrollView style={{ width: "100%" }} _contentContainerStyle={{
            px: {
                base: 15,
                md: 15,
            },
        }}>
				<native_base_1.View w={{ base: "100%", md: "90%", lg: "75%", xl: "65%" }} pb="10">
					<native_base_1.VStack mt="20">
						<native_base_1.HStack alignItems="center">
							<native_base_1.Pressable padding={5} onPress={onBackPressed} mr={10}>
								<native_base_1.Image source={icons_1.default.icClose} w={18} h={18}/>
							</native_base_1.Pressable>
							<native_base_1.Text>Agenda tu próxima reunión</native_base_1.Text>
						</native_base_1.HStack>
						{/*date time*/}
						<native_base_1.HStack mt={20} alignItems="stretch" borderBottomWidth={1} borderBottomColor="colorDarkGray1">
							<input width={0} height={0} style={{
            position: "absolute",
            visibility: "hidden",
            height: 0,
            width: 0,
        }} ref={inputDateRef} type="date" onChange={e => {
            console.log("e.target.value", e.target.value);
            setDay(e.target.value);
        }}/>
							<native_base_1.Pressable onPress={onDayPressed} flex={1}>
								<native_base_1.HStack alignItems="center" borderRadius={10} py={5} minH={50}>
									<native_base_1.Text flex={1}>{day ?? "Fecha"}</native_base_1.Text>
									<native_base_1.Image mx={10} alt="_" source={icons_1.default.imgCalendar} width={25} h={25}/>
								</native_base_1.HStack>
							</native_base_1.Pressable>
							{day && (<native_base_1.HStack alignItems="center">
									<native_base_1.Pressable onPress={onClearDatePressed}>
										<native_base_1.View background="black" p={5} borderRadius={12}>
											<native_base_1.Image alt="_" source={icons_1.default.icClose} width={15} h={15} background="black" style={{ tintColor: "white" }}/>
										</native_base_1.View>
									</native_base_1.Pressable>
								</native_base_1.HStack>)}
						</native_base_1.HStack>
						<native_base_1.HStack mt={20} borderBottomWidth={1} borderBottomColor="colorDarkGray1">
							<native_base_1.HStack flex={1} alignItems="center" pr={15}>
								<native_base_1.Select flex={1} key={hour} borderWidth={0} selectedValue={hour} minWidth="40" accessibilityLabel="Choose Service" placeholder="Hora" _selectedItem={{
            //bg: "teal.600",
            endIcon: <native_base_1.CheckIcon size="5"/>,
        }} mt={1} onValueChange={itemValue => setHour(itemValue)}>
									{_.range(0, 24).map((e, i) => (<native_base_1.Select.Item key={"asd" + i} label={e.toString()} value={e.toString()}/>))}
								</native_base_1.Select>
								<native_base_1.Image alt="_" source={icons_1.default.icMore} w={12} h={12} ml={20}/>
							</native_base_1.HStack>

							<native_base_1.HStack ml={10} flex={1} alignItems="center" pr={15}>
								<native_base_1.Select flex={1} key={minute} borderWidth={0} selectedValue={minute} minWidth="40" accessibilityLabel="Choose minute" placeholder="Minuto" _selectedItem={{
            bg: "teal.600",
            endIcon: <native_base_1.CheckIcon size="5"/>,
        }} mt={1} onValueChange={itemValue => setMinute(itemValue)}>
									{_.range(0, 60).map((e, i) => (<native_base_1.Select.Item background="colorLine" key={i} label={e.toString()} value={e.toString()}/>))}
								</native_base_1.Select>
								<native_base_1.Image alt="_" source={icons_1.default.icMore} w={12} h={12} ml={20}/>
							</native_base_1.HStack>
							<native_base_1.HStack alignItems="center">
								<native_base_1.Image mx={10} alt="_" source={icons_1.default.imgClock} w={25} h={25}/>
								{(hour || minute) && (<native_base_1.Pressable onPress={onClearHourMinutePressed}>
										<native_base_1.View background="black" p={5} borderRadius={12}>
											<native_base_1.Image alt="_" source={icons_1.default.icClose} width={15} h={15} background="black" style={{ tintColor: "white" }}/>
										</native_base_1.View>
									</native_base_1.Pressable>)}
							</native_base_1.HStack>
						</native_base_1.HStack>
						{/*clien new or not*/}
						<native_base_1.HStack alignItems="center" mt={20}>
							<native_base_1.Text flex={1}>Cliente nuevo</native_base_1.Text>
							<native_base_1.HStack borderWidth={1} borderColor={theme_1.Colors.colorGray1} borderRadius={10}>
								<native_base_1.Pressable onPress={onClientNewPressed}>
									<native_base_1.Text variant="body5" px={7} bg={clientNew ? theme_1.Colors.colorVividYellow1 : "white"} borderTopLeftRadius={10} borderBottomLeftRadius={10}>
										Si
									</native_base_1.Text>
								</native_base_1.Pressable>
								<native_base_1.Pressable onPress={onClientNoNewPressed}>
									<native_base_1.Text variant="body5" px={7} bg={!clientNew ? theme_1.Colors.colorVividYellow1 : "white"} borderTopRightRadius={10} borderBottomRightRadius={10}>
										No
									</native_base_1.Text>
								</native_base_1.Pressable>
							</native_base_1.HStack>
						</native_base_1.HStack>

						{clientNew && (<>
								<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
									<native_base_1.Text mr={20} minW={95}>
										Nombre:{" "}
									</native_base_1.Text>
									<react_native_1.TextInput style={[styles.input, { flex: 1 }]} value={clientNewName} onChange={onNameChanged}/>
								</native_base_1.HStack>
								<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
									<native_base_1.Text mr={20} minW={95}>
										Ruc:{" "}
									</native_base_1.Text>
									<react_native_1.TextInput style={[styles.input, { flex: 1 }]} value={clientNewRuc} keyboardType="numeric" maxLength={11} onChange={onRucChanged}/>
								</native_base_1.HStack>
								<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
									<native_base_1.Text mr={20} minW={95}>
										Telefono:{" "}
									</native_base_1.Text>
									<react_native_1.TextInput style={[styles.input, { flex: 1 }]} value={clientNewPhone} keyboardType="numeric" maxLength={9} onChange={onPhoneChanged}/>
								</native_base_1.HStack>
								<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
									<native_base_1.Text mr={20} minW={95}>
										Dirección:{" "}
									</native_base_1.Text>
									<react_native_1.TextInput style={[styles.input, { flex: 1 }]} value={clientNewAddress} onChange={onAddressChanged}/>
								</native_base_1.HStack>
								<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
									<native_base_1.Text mr={20} minW={95} flex={1}>
										Potencial cliente:{" "}
									</native_base_1.Text>

									<native_base_1.HStack borderWidth={1} borderColor={theme_1.Colors.colorGray1} borderRadius={10}>
										<native_base_1.Pressable onPress={() => {
                setClientNewPot(true);
            }}>
											<native_base_1.Text variant="body5" px={7} bg={clientNewPot ? theme_1.Colors.colorVividYellow1 : "white"} borderTopLeftRadius={10} borderBottomLeftRadius={10}>
												Si
											</native_base_1.Text>
										</native_base_1.Pressable>
										<native_base_1.Pressable onPress={() => {
                setClientNewPot(false);
            }}>
											<native_base_1.Text variant="body5" px={7} bg={!clientNewPot ? theme_1.Colors.colorVividYellow1 : "white"} borderTopRightRadius={10} borderBottomRightRadius={10}>
												No
											</native_base_1.Text>
										</native_base_1.Pressable>
									</native_base_1.HStack>
								</native_base_1.HStack>

								<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
									<native_base_1.Text mr={20} minW={95}>
										Marca:{" "}
									</native_base_1.Text>
									<native_base_1.Pressable onPress={() => {
                setShowSelectClientNewBrand(true);
            }} style={[{ flex: 1 }]} borderRadius={theme_1.Sizes.inputRadius} borderWidth={theme_1.Sizes.inputBorderWidth} minH={40} py={0}>
										<native_base_1.HStack alignItems="center" minH={40} px={10}>
											<native_base_1.Text flex={1}>
												{brandsClientNewSelected?.map(e => e.name ?? "")?.join(", ")}
											</native_base_1.Text>
											<native_base_1.Image w={10} h={10} source={icons_1.default.icMore}/>
										</native_base_1.HStack>
									</native_base_1.Pressable>
									<ModalSelectRoadmapClientNewBrand_1.default isOpen={showSelectClientNewBrand} onClose={() => {
                setShowSelectClientNewBrand(false);
            }} items={initResponse?.data?.marcasClienteNuevo} onAcceptPressed={items => {
                setBrandsClientNewSelected(items);
                setShowSelectClientNewBrand(false);
            }}/>
								</native_base_1.HStack>

								{/* adress*/}

								<native_base_1.Pressable w="100%" mt="20" mr={15} onPress={() => {
                setShowModalMap(true);
            }}>
									<native_base_1.HStack w="100%" px={15} py={5} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} alignItems="center">
										<native_base_1.Text flex={1}>{address ?? "Ubicacion"}</native_base_1.Text>
										<native_base_1.Image source={icons_1.default.icMarker} w={15} h={15}/>
									</native_base_1.HStack>
								</native_base_1.Pressable>

								<native_base_1.VStack mt={20}>
									<native_base_1.Pressable onPress={() => {
                dropzoneRef.current?.open();
            }}>
										<native_base_1.HStack px={15} py={5} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} alignItems="center">
											<native_base_1.Image source={icons_1.default.icPlus} w={10} h={10} mr={10}/>
											<native_base_1.Text>{files?.[0]?.name ?? "Cargar foto del local"}</native_base_1.Text>
										</native_base_1.HStack>
									</native_base_1.Pressable>
									<react_dropzone_1.default ref={dropzoneRef} onDrop={onDrop} onError={err => {
                console.log(err);
            }} maxFiles={1} multiple={false} accept={{
                "image/png": [".png", ".jpg", ".jpeg"],
                //"application/pdf": [".pdf"],
            }}>
										{({ getRootProps, getInputProps, isDragActive }) => (<div {...getRootProps()} style={{ width: "100%" }}>
												<input {...getInputProps()}/>
												{isDragActive ? (<p style={{
                        marginLeft: 20,
                        flex: 1,
                        width: "100%",
                    }}></p>) : (<p style={{
                        marginLeft: 20,
                        flex: 1,
                        width: "100%",
                    }}></p>)}
											</div>)}
									</react_dropzone_1.default>
								</native_base_1.VStack>

								<native_base_1.HStack mt={20} alignItems="center">
									<native_base_1.HStack alignItems="center" backgroundColor="white" borderRadius={10} shadow={1} py={5} flex={1}>
										<native_base_1.Text px={15}>{roadmapObjectiveContact?.name ?? "Objetivo de contacto"}</native_base_1.Text>
									</native_base_1.HStack>

									<TypeContactItem ml={10} flex={1} items={initResponse?.data?.tiposContacto} selectedItem={roadmapTypeContact} onPressed={onRoadmapTypeContactPressed}/>
								</native_base_1.HStack>
							</>)}

						{!clientNew && (<native_base_1.HStack mt={20} alignItems="start">
								<native_base_1.Pressable onPress={onSocioPressed} alignSelf="start" flex={1} mr={10}>
									<native_base_1.HStack alignItems="center" backgroundColor="white" borderRadius={10} shadow={1} px={15} py={5}>
										<native_base_1.Text>{client?.nombre ?? "Elegir cliente"}</native_base_1.Text>
										<native_base_1.Image alt="_" source={icons_1.default.icSearch} w={15} h={15} ml={20}/>
									</native_base_1.HStack>
								</native_base_1.Pressable>

								<TypeContactItem flex={1} items={initResponse?.data?.tiposContacto} selectedItem={roadmapTypeContact} onPressed={onRoadmapTypeContactPressed}/>
							</native_base_1.HStack>)}

						{!clientNew && (<>
								<native_base_1.VStack mt={20} backgroundColor="white" borderRadius={10} shadow={1}>
									<native_base_1.Pressable onPress={onObjectivePressed} alignSelf="stretch">
										<native_base_1.HStack alignItems="center" px={15} py={10}>
											<native_base_1.Text flex={1} mr={15}>
												Objetivo de contacto
											</native_base_1.Text>
											<native_base_1.Image alt="_" source={icons_1.default.icMore} w={12} h={12} ml={20}/>
										</native_base_1.HStack>
									</native_base_1.Pressable>
									{objectiveContactVisible && (<>
											<native_base_1.FlatList renderItem={renderItem} data={objectiveContactChecklist}/>
										</>)}
								</native_base_1.VStack>
							</>)}

						<native_base_1.Button onPress={onAddPressed} alignSelf="start" my={30}>
							Agendar
						</native_base_1.Button>
					</native_base_1.VStack>
				</native_base_1.View>
			</native_base_1.ScrollView>
			<ModalCancelRoadmapAdd_1.default isOpen={showCancelRoadmapAddDialog} onClose={() => {
            setShowCancelRoadmapAddDialog(false);
        }} onYesPress={onContinueEditingYesPressed} onCancelPress={onContinueEditingNoPressed}/>
			<ModalRoadmapMap_1.default isOpen={showModalMap} onClose={() => {
            setShowModalMap(false);
        }} onAccept={(address, lat, lng) => {
            setAddress(address);
            latRef.current = lat;
            lngRef.current = lng;
            setShowModalMap(false);
        }}/>
			<FullScreenLoad_1.default isVisible={isLoading}/>
		</>);
};
const TypeContactItem = ({ items, selectedItem, onPressed, ...rest }) => {
    return (<native_base_1.Menu trigger={triggerProps => {
            console.log(triggerProps);
            return (<native_base_1.Pressable bg="white" borderRadius={10} shadow={2} accessibilityLabel="More options menu" {...triggerProps} {...rest}>
						<native_base_1.HStack alignItems="center" px="15" py="5">
							<native_base_1.Text flex={1}>{selectedItem?.name ?? "Tipo de contacto"}</native_base_1.Text>
							<native_base_1.View w={10}/>
							<native_base_1.Image source={icons_1.default.icChevronDownFilled} w={10} h={10}/>
						</native_base_1.HStack>
					</native_base_1.Pressable>);
        }}>
			{items?.map(e => {
            return (<native_base_1.Menu.Item onPress={() => {
                    onPressed(e);
                }}>
						<native_base_1.HStack alignItems="center" px={10}>
							<native_base_1.Image alt="_" source={e.code == RoadmapTypeContactEntity_1.RoadmapTypeContact.call ? icons_1.default.icPhoneOutline : icons_1.default.imgHomeOutline} w={15} h={15} mr={15}/>
							<native_base_1.Text>{e.name ?? ""}</native_base_1.Text>
						</native_base_1.HStack>
					</native_base_1.Menu.Item>);
        })}
		</native_base_1.Menu>);
};
const ObjectiveContactItem = ({ item, onItemPressed }) => {
    const onPressed = (option) => {
        onItemPressed(item, option);
    };
    const renderItem = ({ item }) => {
        return <ObjectiveContactOptionItem item={item} onItemPressed={onPressed}/>;
    };
    return (<native_base_1.VStack>
			<native_base_1.Text flex={1} py={5} px={15} mt={10}>
				{item.nombre ?? ""}
			</native_base_1.Text>
			<native_base_1.FlatList renderItem={renderItem} data={item.opciones}/>
		</native_base_1.VStack>);
};
const ObjectiveContactOptionItem = ({ item, onItemPressed }) => {
    const onPressed = () => {
        onItemPressed(item);
    };
    return (<native_base_1.Pressable onPress={onPressed}>
			<native_base_1.HStack mt={0} borderBottomWidth={1} borderBottomColor={theme_1.Colors.colorLightGray1} px={15} alignItems="center" py={5}>
				<native_base_1.Text flex={1} py={5} color={theme_1.Colors.colorDarkGray1}>
					{item.name ?? ""}
				</native_base_1.Text>
				<native_base_1.View w={20} h={20} alignItems="center" justifyContent="center" borderColor={theme_1.Colors.colorDarkGray1} borderWidth={1} borderRadius={5}>
					{item.check == "1" && <native_base_1.Image source={icons_1.default.icCheck} w={12} h={12}/>}
				</native_base_1.View>
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
const styles = react_native_1.StyleSheet.create({
    input: {
        padding: theme_1.Sizes.inputPaddingHorizontal,
        height: theme_1.Sizes.inputMinHeight - 10,
        borderRadius: theme_1.Sizes.inputRadius,
        borderWidth: theme_1.Sizes.inputBorderWidth,
        backgroundColor: "#ffffff",
    },
});
exports.name = "PlanningRoadmapAddName";
exports.default = PlanningRoadmapAdd;
